// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 854 ? "pdfjs" : chunkId) + "." + {"549":"503ee804","854":"b5c3042c"}[chunkId] + ".chunk.js";
};